export default function (cep) {

  cep = cep.replace(/[^\d]+/g, '')

  if (cep == '')
    return false

  if (cep.length != 8)
    return false

  return true
}



// WEBPACK FOOTER //
// ./src/config/validations/cep.js